(function () {
    'use strict';

    angular.module('UndergroundWebApp').controller('ContainerItemTypeDetailsModalController', ContainerItemTypeDetailsModalController);

    ContainerItemTypeDetailsModalController.$inject = [
        '$q',
        '$scope',
        '$rootScope',
        '$windowInstance',
        'containerItemTypesService',
        'formTypes',
        'currentFormType',
        'containerItemType'
    ];

    function ContainerItemTypeDetailsModalController(
        $q,
        $scope,
        $rootScope,
        $windowInstance,
        containerItemTypesService,
        formTypes,
        currentFormType,
        containerItemType
    ) {
        $scope.saveAndClose = saveAndClose;
        $scope.closeWindow = closeWindow;

        $scope.containerItemType = containerItemType ? { ...containerItemType } : { name: '' };

        function saveAndClose(event) {
            event.preventDefault();

            if ($scope.validator.validate()) {
                save().then(function (result) {
                    $windowInstance.close(result);
                    $('#container-item-types-grid').getKendoGrid().dataSource.read();
                });
            }
        }

        function closeWindow(result) {
            $windowInstance.close(result);
        }

        function getSaveFunction(currentFormType) {
            if (currentFormType === formTypes.edit) {
                return containerItemTypesService.updateContainerItemType.bind(containerItemTypesService);
            }

            return containerItemTypesService.addContainerItemType.bind(containerItemTypesService);
        }

        function save() {
            var deferred = $q.defer();

            $rootScope.$broadcast('showGlobalBusyIndicator', 'containerItemTypeIndicator');

            var saveFunction = getSaveFunction(currentFormType);

            saveFunction($scope.containerItemType)
                .then(result => deferred.resolve(result),
                    () => deferred.reject())
                .finally(() => $rootScope.$broadcast('hideBusyIndicator', 'containerItemTypeIndicator'));

            return deferred.promise;
        }
    }
})();
